var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayPlaying = function SvgPlayPlaying(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M15,55 L29,55 C30.6568542,55 32,56.3431458 32,58 L32,77 C32,78.6568542 30.6568542,80 29,80 L15,80 C13.3431458,80 12,78.6568542 12,77 L12,58 C12,56.3431458 13.3431458,55 15,55 Z M67,38 L81,38 C82.6568542,38 84,39.3431458 84,41 L84,77 C84,78.6568542 82.6568542,80 81,80 L67,80 C65.3431458,80 64,78.6568542 64,77 L64,41 C64,39.3431458 65.3431458,38 67,38 Z M41,17 L55,17 C56.6568542,17 58,18.3431458 58,20 L58,77 C58,78.6568542 56.6568542,80 55,80 L41,80 C39.3431458,80 38,78.6568542 38,77 L38,20 C38,18.3431458 39.3431458,17 41,17 Z"
  })));
};
export default SvgPlayPlaying;